
let language = {

    FILE_LIBRARY_NO_MORE_CONTENT_TIP: "没有更多内容...",
    FILE_LIBRARY_NO_MATCH_SEARCH_TIP: "没有匹配的搜索条件.",
    FILE_LIBRARY_FOLDER_EMPTY_TIP: "这个文件夹为空",
    FILE_LIBRARY_NOT_HAVE_FILE_LIBRARY_TIP: "您还没有文件库，请点击下面按钮创建文件库",
};

export { language }